module.exports = __webpack_public_path__ + "static/img/hospital2.9325317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hospital2.png
// module id = DBl0
// module chunks = 1